export const InterFontNames = {
    normal: '"Inter"',
    var: '"Inter var"',
};
const fontFamily = InterFontNames.normal;
const fontStyle = 'normal';
const base = 'https://rsms.me/inter/font-files';
const version = 3.11;
function normalizeUrl(url) {
    return url
        .replace(/([^:])\/\//g, '$1/') // replace double slashes, except starting with a colon
        .replace(/\.\./g, '.'); // replace double dots
}
// eslint-disable-next-line @typescript-eslint/no-shadow
function getSingleFontFaceSrc({ base, version, name, format }) {
    const url = normalizeUrl(`${base}/${name}.${format}?v=${version}`);
    return `url("${url}") format("${format}")`;
}
export function getFontFaceSrc(props, formats = ['woff', 'woff2']) {
    return formats.map((format) => getSingleFontFaceSrc(Object.assign(Object.assign({}, props), { format }))).join(',');
}
const InterLight = {
    fontFamily,
    fontStyle,
    fontWeight: 300,
    src: getFontFaceSrc({ base, version, name: 'Inter-Light' }),
};
const InterNormal = {
    fontFamily,
    fontStyle,
    fontWeight: 400,
    src: getFontFaceSrc({ base, version, name: 'Inter-Regular' }),
};
const InterMedium = {
    fontFamily,
    fontStyle,
    fontWeight: 500,
    src: getFontFaceSrc({ base, version, name: 'Inter-Medium' }),
};
const InterBold = {
    fontFamily,
    fontStyle,
    fontWeight: 700,
    src: getFontFaceSrc({ base, version, name: 'Inter-Bold' }),
};
const InterVar = {
    fontFamily: InterFontNames.var,
    fontStyle,
    fontWeight: '100 900',
    fontDisplay: 'swap',
    fontNamedInstance: '"Regular"',
    src: getFontFaceSrc({ base, version, name: 'Inter-roman.var' }, ['woff2']),
};
export const Inter = [InterLight, InterNormal, InterMedium, InterBold, InterVar];
//# sourceMappingURL=Inter.js.map